import { jsx, jsxs } from 'react/jsx-runtime';
import Markdown from 'markdown-to-jsx';
import { Modal } from '../../display/Modal/Modal.es.js';
import { ModalContent, ModalContentHeader, ModalContentBody, ModalContentFooter } from '../../display/Modal/ModalContent.es.js';
import { LegacyButton } from '../../navigation/LegacyButton/Button.es.js';

const title = "_title_mb4gv_1";
const markdown = "_markdown_mb4gv_7";
const styles = {
	title: title,
	markdown: markdown
};

const PolicyModal = ({ onAccept, title, tldr, url, renderMarkdown = (markdown) => jsx(Markdown, { children: markdown }) }) => {
  return jsx(Modal, { canClose: false, onClosed: () => {
  }, children: jsxs(ModalContent, { maxWidth: "70ch", children: [jsx(ModalContentHeader, { children: jsxs("h1", { "data-zds": true, className: styles.title, children: ["We’ve updated the ", title] }) }), jsx(ModalContentBody, { scrollable: true, children: jsx("div", { className: styles.markdown, "data-zds": true, children: renderMarkdown(tldr) }) }), jsxs(ModalContentFooter, { children: [!!url && jsx(LegacyButton, { color: "secondary", href: url, target: "_blank", children: "Review changes" }), jsx(LegacyButton, { color: "primary", hasShadow: true, onClick: onAccept, children: "Accept" })] })] }) });
};

export { PolicyModal };
//# sourceMappingURL=PolicyModal.es.js.map
